import { Annotation } from "@codemirror/state";

export const copilotEvent = Annotation.define<null>();
